import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CookieInfoComponent } from './cookieinfo.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    CookieInfoComponent
  ],
  exports: [
    CookieInfoComponent
  ]
})
export class CookieInfoModule {

} 
